module.exports = __webpack_public_path__ + "img/assetediting.dacba3dd.gif";